import { SubmissionSessionFragment } from 'src/containers/Booking/containers/BookingParticipantsContainer/data/SubmissionSessionFragment.fragment';
import { graphql } from 'src/graphql';

export const ReportIssue = graphql(
  `
    mutation ReportIssue(
      $bookingId: ID!
      $bookingSubmissionId: ID!
      $reportRequest: ReportRequest
      $reportReason: ReportReason!
      $reportDetails: String
    ) {
      reportIssue(
        booking_id: $bookingId
        booking_submission_id: $bookingSubmissionId
        report_request: $reportRequest
        report_reason: $reportReason
        report_details: $reportDetails
      ) {
        _id
        status
        ...SubmissionSessionFragment
      }
    }
  `,
  [SubmissionSessionFragment],
);
